// extracted by mini-css-extract-plugin
export default {"plate":"sjo7y8c83Q487GnU8ByJ","form":"DPJulqhxYIEcizF9npHS","actionButtons":"du6sMrc1gD1giL8PWIeU","button":"i38WFv4TxIKV6cH_og2k","fadeIn":"tsvR1PZx1szWb2Cg976g"};